"use client";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Rightchat from "../components/Rightchat";
import Appfooter from "../components/Appfooter";
import Popupchat from "../components/Popupchat";
import { useAuth } from "../context/AuthContext";
import { useProfile } from "../context/ProfileContext";

const Settings: React.FC = () => {

  const auth = useAuth();
  const { availableProfiles, openSelectionModal, refreshProfiles } = useProfile();

  const user = auth?.user as { role?: string } | null;
  const isAdmin = user?.role === "ADMIN";
  
  // Verifica se o usuário tem registro de organizador (tem ligas disponíveis)
  const temOrganizadorAtivo = availableProfiles.some((p) => p.tipo === 'LIGA');

  const handleLogout = () => {
    auth?.logout();
    window.location.href = "/login"; // Redirect to login page after logout
  };

  const handleOpenProfileSelection = async () => {
    try {
      await refreshProfiles();
    } finally {
      openSelectionModal();
    }
  };
  return (
    <Fragment>
      <Header />

      <div className="main-content theme-dark-bg right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                <div className="card-body p-lg-5 p-4 w-100 border-0">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4 className="mb-4 font-xxl fw-700 mont-font mb-lg-5 mb-4 font-md-xs">
                        Configurações
                      </h4>
                      <div className="nav-caption fw-600 font-xssss text-grey-500 mb-2">
                        Geral
                      </div>
                      <ul className="list-inline mb-4">
                        <li className="list-inline-item d-block border-bottom me-0">
                          <Link
                            to="/accountinformation"
                            className="pt-2 pb-2 d-flex align-items-center"
                          >
                            <i className="btn-round-md bg-primary text-white bi bi-house font-md me-3"></i>{" "}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              Informações da conta
                            </h4>
                            <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                          </Link>
                        </li>
                      </ul>

                      <div className="nav-caption fw-600 font-xsss text-grey-500 mb-2">
                        Conta
                      </div>
                      <ul className="list-inline mb-4">
                        {!isAdmin && (
                          <li className="list-inline-item d-block border-bottom me-0">
                            <Link
                              to="/athlete/financeiro"
                              className="pt-2 pb-2 d-flex align-items-center"
                            >
                              <i className="btn-round-md bg-primary text-white bi bi-credit-card font-md me-3"></i>{" "}
                              <h4 className="fw-600 font-xsss mb-0 mt-0">
                                Financeiro
                              </h4>
                              <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                            </Link>
                          </li>
                        )}
                        {temOrganizadorAtivo && (
                          <li className="list-inline-item d-block border-bottom me-0">
                            <button
                              type="button"
                              onClick={handleOpenProfileSelection}
                              className="pt-2 pb-2 d-flex align-items-center w-100 bg-transparent border-0 text-start"
                            >
                              <i className="btn-round-md bg-primary text-white bi bi-person-badge font-md me-3"></i>{" "}
                              <h4 className="fw-600 font-xsss mb-0 mt-0">
                                Selecionar perfil
                              </h4>
                              <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                            </button>
                          </li>
                        )}
                        <li className="list-inline-item d-block  me-0">
                          <Link
                            to="/password"
                            className="pt-2 pb-2 d-flex align-items-center"
                          >
                            <i className="btn-round-md bg-primary text-white bi bi-inbox font-md me-3"></i>{" "}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              Alterar senha
                            </h4>
                            <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                          </Link>
                        </li>
                      </ul>

                      {isAdmin && (
                        <>
                          <div className="nav-caption fw-600 font-xsss text-grey-500 mb-2">
                            Administração
                          </div>
                          <ul className="list-inline mb-4">
                            <li className="list-inline-item d-block border-bottom me-0">
                              <Link
                                to="/admin/paymentmethods/"
                                className="pt-2 pb-2 d-flex align-items-center"
                              >
                                <i className="btn-round-md bg-primary text-white bi bi-credit-card font-md me-3"></i>{" "}
                                <h4 className="fw-600 font-xsss mb-0 mt-0">
                                  Meios de Pagamentos
                                </h4>
                                <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                              </Link>
                            </li>
                            <li className="list-inline-item d-block me-0">
                              <Link
                                to="/admin/emailsnotificacoes"
                                className="pt-2 pb-2 d-flex align-items-center"
                              >
                                <i className="btn-round-md bg-primary text-white bi bi-envelope font-md me-3"></i>{" "}
                                <h4 className="fw-600 font-xsss mb-0 mt-0">
                                  Emails e notificações
                                </h4>
                                <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                              </Link>
                            </li>
                          </ul>
                        </>
                      )}

                      <div className="nav-caption fw-600 font-xsss text-grey-500 mb-2">
                        Outros
                      </div>
                      <ul className="list-inline">
                        <li className="list-inline-item d-block border-bottom me-0">
                          <Link
                            to="/defaultnotification"
                            className="pt-2 pb-2 d-flex align-items-center"
                          >
                            <i className="btn-round-md bg-primary text-white bi bi-bell font-md me-3"></i>{" "}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              Notificações
                            </h4>
                            <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                          </Link>
                        </li>
                        <li className="list-inline-item d-block me-0">
                          <a
                            onClick={handleLogout}
                            className="pt-2 pb-2 d-flex align-items-center cursor-pointer"
                          >
                            <i className="btn-round-md bg-primary text-white bi bi-lock font-md me-3"></i>{" "}
                            <h4 className="fw-600 font-xsss mb-0 mt-0">
                              Logout
                            </h4>
                            <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </Fragment>
  );
};

export default Settings;
